import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { Loader2, Shield } from 'lucide-react';
import JourneyLayout from '../../components/JourneyLayout';

function AccountAggregator() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [checkingAuth, setCheckingAuth] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkLoginStatus = async () => {
      setCheckingAuth(true);
      const token = localStorage.getItem('token') || 
                    localStorage.getItem('authToken') || 
                    localStorage.getItem('authtoken');
      const profileId = localStorage.getItem('profile_id') || '';

      console.log(token, profileId);
      
      if (!token || !profileId) {
        navigate('/apply-now');
        return;
      }
      setCheckingAuth(false);
    };

    checkLoginStatus();
  }, [navigate]);

  useEffect(() => {
    if (checkingAuth) return;

    const initiateAccountAggregator = async () => {
      const profileId = localStorage.getItem('profile_id') || '';
      if (!profileId) {
        setError('Session expired. Please login again.');
        setTimeout(() => navigate('/apply-now'), 2000);
        return;
      }

      try {
        // First, get dashboard data to fetch lead_id
        const dashboardResponse = await authAPI.getDashboardData(profileId);
        
        if (dashboardResponse.Status !== 1) {
          setError('Failed to fetch dashboard data. Please try again.');
          setLoading(false);
          return;
        }

        const leadId = dashboardResponse.Data?.profile_details?.lead_id || '';
        
        // Now call initiate account aggregator API
        const response = await authAPI.initiateAccountAggregator({
          lead_id: leadId,
          profile_id: profileId,
        });

        if (response.Status === 1 && response.RedirectionUrl) {
          // Navigate to the redirection URL in the same window
          window.location.href = response.RedirectionUrl;
        } else {
          setError(response.Message || 'Failed to initiate Account Aggregator. Please try again.');
          setLoading(false);
        }
      } catch (err) {
        setError(err.message || 'Failed to initiate Account Aggregator. Please try again.');
        setLoading(false);
      }
    };

    initiateAccountAggregator();
  }, [navigate, checkingAuth]);

  if (checkingAuth) {
    return (
      <JourneyLayout journeyStep={5}>
        <div className="flex items-center justify-center min-h-[400px]">
          <Loader2 className="h-8 w-8 animate-spin text-theme" />
        </div>
      </JourneyLayout>
    );
  }

  if (loading) {
    return (
      <JourneyLayout journeyStep={5}>
        <div className="text-center space-y-6 py-12">
          <div className="flex justify-center">
            <div className="bg-theme/10 p-4 rounded-full">
              <Shield className="h-12 w-12 text-theme" />
            </div>
          </div>
          <Loader2 className="h-10 w-10 text-theme animate-spin mx-auto" />
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Account Aggregator</h2>
          <p className="text-gray-600 text-lg">Initializing eKYC process...</p>
          <p className="text-gray-500 text-sm">Please wait while we set up your account verification</p>
        </div>
      </JourneyLayout>
    );
  }

  if (error) {
    return (
      <JourneyLayout journeyStep={5}>
        <div className="text-center space-y-6 py-12">
          <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-6 max-w-md mx-auto">
            <p className="text-red-700 font-semibold">{error}</p>
          </div>
          <button
            onClick={() => navigate('/other-information')}
            className="bg-gradient-to-r from-theme to-theme2 text-white px-6 py-3 rounded-2xl font-semibold hover:opacity-90 transition-opacity shadow-lg"
          >
            Try Again
          </button>
        </div>
      </JourneyLayout>
    );
  }

  return null;
}

export default AccountAggregator;

